import { Lightbulb, FileSearch, Workflow, ShieldAlert, Sparkles, FileCheck, FileText } from "lucide-react";

const services = [
  { icon: Lightbulb, label: "Consultoria estratégica" },
  { icon: FileSearch, label: "Auditorias jurídicas preventivas" },
  { icon: Workflow, label: "Revisão de práticas empresariais" },
  { icon: ShieldAlert, label: "Investigação defensiva" },
  { icon: Sparkles, label: "Gestão de contencioso estratégico" },
  { icon: FileText, label: "Produção de provas" },
  { icon: FileCheck, label: "Estruturação documental e contratual" },
];

export default function AdvocaciaEstrategica() {
  return (
    <section
      id="advocacia-estrategica"
      className="section bg-brand-primary text-white relative overflow-hidden"
      data-testid="section-advocacia-estrategica"
    >
      <div className="absolute inset-0 grain opacity-50" aria-hidden />
      {/* Big serif background letter */}
      <span
        aria-hidden
        className="pointer-events-none select-none absolute -top-10 -right-10 font-serif text-[420px] leading-none text-white/[0.04]"
      >
        G
      </span>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5">
          <p className="eyebrow text-brand-accent mb-6"><span className="thin-rule" />Estratégia & Prevenção</p>
          <h2 className="font-serif text-white font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
            Advocacia Estratégica<br />e <em className="not-italic text-brand-accent">Preventiva</em>.
          </h2>
          <p className="mt-6 text-[15px] leading-relaxed text-white/75 max-w-md">
            Acreditamos que uma atuação jurídica eficiente começa antes do conflito.
          </p>
          <p className="mt-4 text-[15px] leading-relaxed text-white/75 max-w-md">
            Por isso, desenvolvemos soluções preventivas que auxiliam empresas e pessoas na
            identificação de riscos, tomada de decisões seguras e construção de estratégias
            jurídicas sólidas.
          </p>
          <p className="mt-4 text-[13px] tracking-wide text-brand-accent uppercase max-w-md">
            Nossa atuação inclui:
          </p>
          <p className="mt-8 font-serif text-2xl lg:text-3xl text-brand-accent italic max-w-md leading-snug">
            “Mais do que reagir a problemas, atuamos para prevenir riscos e proteger interesses.”
          </p>
        </div>

        <div className="lg:col-span-7">
          <div className="grid sm:grid-cols-2 gap-px bg-white/10">
            {services.map(({ icon: Icon, label }, i) => (
              <div
                key={label}
                className="bg-brand-primary p-8 lg:p-10 hover:bg-brand-primary2 transition-colors"
                data-testid={`advocacia-service-${i}`}
              >
                <Icon size={26} className="text-brand-accent" strokeWidth={1.4} />
                <p className="mt-6 font-serif text-2xl text-white leading-tight">{label}</p>
                <div className="mt-4 h-px w-10 bg-brand-accent/60" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
